import { useToast } from '@ais-ui/ui-core';
import React, { useState } from 'react';

import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useCreateAton } from '@ais-ui/api';

import {
  convertVirtualAtonValuesToBackend,
  mutateVirtualAtonFormSchema,
  MutateVirtualAtonFormValues,
} from './atonForm';
import { AtonVirtualDialog } from './AtonVirtualDialog';
import { mutateCallbacks } from '../../utils/mutateCallbacks';
import { useLocalization } from '@ais-ui/locale-management';
import { useAtonContext } from '../AtonContext';

export const CreateVirtualAton = () => {
  const { messages } = useLocalization();
  const { mutate } = useCreateAton();

  const { setShowDialog } = useAtonContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { toast } = useToast();
  const virtualForm = useForm<MutateVirtualAtonFormValues>({
    resolver: zodResolver(mutateVirtualAtonFormSchema),
    defaultValues: {
      enabled: true,
      name: '',
      description: '',
      type: '0',
      virtual: '1',
      sizeA: 0,
      sizeB: 0,
      sizeC: 0,
      sizeD: 0,
      broadcastInterval: '00:06:00',
      warningTimeout: '00:07:00',
      failureTimeout: '00:13:00',
      schedule: [],
      pss: [],
      chained: '',
      selectedGroups: [],
    },
  });

  const onCreateVirtual = async (data: MutateVirtualAtonFormValues) => {
    const backendValues = convertVirtualAtonValuesToBackend(data);
    setIsSubmitting(true);

    const callBacks = mutateCallbacks(
      toast,
      messages,
      'create',
      'aton',
      setIsSubmitting,
      setShowDialog
    );

    mutate(backendValues, callBacks);
  };

  return (
    <AtonVirtualDialog
      form={virtualForm}
      onSubmit={onCreateVirtual}
      mutateType="create"
      isSubmitting={isSubmitting}
      setShowOuterDialog={setShowDialog}
    />
  );
};
